import { IConfig } from 'src/interfaces';
import { ConfigActionType } from '../action-types';
import { ConfigAction } from '../actions';

interface ConfigState {
  loading: boolean;
  error: string | null;
  data: { config: IConfig | null };
}

const initialState = {
  loading: false,
  error: null,
  data: { config: null },
};

const reducer = (state: ConfigState = initialState, action: ConfigAction): ConfigState => {
  switch (action.type) {
    case ConfigActionType.GET_CONFIG:
      return { loading: true, error: null, data: { config: null } };
    case ConfigActionType.GET_CONFIG_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case ConfigActionType.GET_CONFIG_FAILURE:
      return { loading: false, error: action.payload, data: { config: null } };
    case ConfigActionType.PATCH_CONFIG_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case ConfigActionType.PATCH_CONFIG_FAILURE:
      return {
        loading: false,
        error: action.payload,
        data: state.data,
      };
    default:
      return state;
  }
};

export default reducer;
